import type { DatasetPlanPositioningEditorProps } from "./dataset-plan-positioning-editor.type";

import PositionPlanPositioning from "@/modules/position-plan-positioning";

import { useDatasetPlanPositioningEditor } from "./dataset-plan-positioning-editor.hook";

const DatasetPlanPositioningEditor = (
  props: DatasetPlanPositioningEditorProps
) => {
  const { positionProps } = useDatasetPlanPositioningEditor(props);

  return <PositionPlanPositioning {...positionProps} />;
};

export default DatasetPlanPositioningEditor;
